export default [
  {
    header: 'Akıllı Enerji Yönetimi',
  },
  {
    title: 'Sayaç Okuma Sistemi',
    route: 'ui-colors',
    icon: 'TrendingDownIcon',
  },

  {
    title: 'Aktif Cihazlar',
    route: 'form-validation',
    icon: 'RadioIcon',
  },
  {
    title: 'Reaktife Giren Cihazlar',
    route: 'btrans-kompresor',
    icon: 'ZapIcon',

  },
  {
    title: 'Raporlar',
    route: 'pages-knowledge-base',
    icon: 'SquareIcon',

  },

  {
    title: 'OSOS Analizi',
    route: 'pages-blog-list',
    icon: 'GitBranchIcon',
  },
  {
    title: 'TEP Hesaplama',
    route: 'pages-teb-hesaplayici',
    icon: 'ArchiveIcon',
  },
  {
    title: 'YEKDEM Birim Fiyatı',
    route: { name: 'apps-e-commerce-product-details', params: { slug: 'apple-watch-series-5-27' } },
    icon: 'AirplayIcon',
  },
  {
    header: 'Yönetim Plattformu',
  },
  {
    title: 'Abone İşlemleri',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Tüm Abone Listesi',
        route: 'extensions-toastification',
      },
      {
        title: 'Abone Kayıt İşlemleri',
        route: 'access-control',
      },
      /*
      {
        title: 'Abone İşlem Merkezi',
        route: '#',
      },
      {
        title: 'Abone Tüketim Tabloları',
        route: '#',
      },

      {
        title: 'Raporlar',
        route: '#',
      },
      */

    ],
  },
  {
    title: 'BTrans Yönetimi',
    icon: 'GitPullRequestIcon',
    children: [
      {
        title: 'Abone Bilgileri Listesi',
        route: 'btrans-aboneler',

      },
      {
        title: 'Dosya İşlemleri',
        route: 'btrans-dosyalar',
      },

    ],

  },
  /*
  {
    title: 'Ana Sayaç İşlemleri',
    icon: 'CpuIcon',
    children: [
      {
        title: 'Sayaç Tanımı',

      },
      {
        title: 'Anasayaç Endeks Girişi',
      },
      {
        title: 'Elektrik Alış/Satış Tablosu',
      },
    ],

  },
*/
]
